import { render, staticRenderFns } from "./OldRouteItinerary.vue?vue&type=template&id=4ade1026&scoped=true"
import script from "./OldRouteItinerary.vue?vue&type=script&setup=true&lang=js"
export * from "./OldRouteItinerary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OldRouteItinerary.vue?vue&type=style&index=0&id=4ade1026&prod&lang=scss&scoped=true"
import style1 from "./OldRouteItinerary.vue?vue&type=style&index=1&id=4ade1026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade1026",
  null
  
)

export default component.exports